import { FORM_ACTION, getRoutes } from '@ui-framework/index';
import DataExportHistoryList from './pages/list/index';
import schema from './schemas/routes.json';
import ErrorPage, { ERROR_PAGE_TYPE } from '../ErrorPage';
import DataExportHistoryListStore from './store/index';

const Pages = ProtectedRoute => ({
  DataExportHistory: (
    <ProtectedRoute
      ErrorPage={ErrorPage}
      ERROR_PAGE_TYPE={ERROR_PAGE_TYPE}
      Component={DataExportHistoryList}
      componentProps={{ action: FORM_ACTION.LIST }}
    />
  ),
});

const routes = ({ ProtectedRoute, BubbleRouteError }) =>
  getRoutes({
    schema,
    ProtectedRoute,
    BubbleRouteError,
    Pages: Pages(ProtectedRoute),
  });

const stores = rootStore => [
  {
    DataExportHistoryListStore: new DataExportHistoryListStore(rootStore),
  },
];

export { DataExportHistoryList, routes, stores };
